// @flow

import {
  localeAllowSwitcherCookie,
  localeDefaultCookie,
  cookiesSetting,
  GLOBAL_DEFAULT_LANGUAGE
} from '../common/constants';

export const storeLanguage = (storageWorker, language, defaultLanguage) => {
  storageWorker.set(
    localeDefaultCookie,
    language || defaultLanguage || GLOBAL_DEFAULT_LANGUAGE,
    cookiesSetting
  );
};

export const getLanguage = (storageWorker, language) => {
  const storedLanguage = storageWorker.get(localeDefaultCookie);

  return storedLanguage || language || GLOBAL_DEFAULT_LANGUAGE;
};

export const getAllowLanguageSwitch = storageWorker => {
  const allowLanguageSwitch = storageWorker.get(localeAllowSwitcherCookie);

  if (!allowLanguageSwitch) return true;

  return allowLanguageSwitch === '1';
};
